/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useState, useEffect } from "react";
import { Plus, Download, X } from "lucide-react";
import DateFilterRange from "./_datefilterrange";
import { useGetUtilitiesSummaryDataQuery, useLazyGetUtilitiesReportExportsQuery  } from "../../lib/apiSlice/property/propertySlice.tsx";
import { toast } from "react-toastify";
import { serverUrl } from "../../../../serverUrl.js";
import { useSearchParams } from "react-router-dom";

export default function UtilitiesFilterDashboard({ onFiltersDashboardChange, onUtilityChanged }) {
    const [selectedProperty, setSelectedProperty] = useState("all");
    const [selectedPeriod, setSelectedPeriod] = useState("month");
    const [showAddModal, setShowAddModal] = useState(false);
    const [showExportModal, setShowExportModal] = useState(false);
    const [exportFormat, setExportFormat] = useState("pdf");
    const [exportOptions, setExportOptions] = useState({
        is_summary: true,
        is_detailed: true,
        is_charts: true
    });

    const [searchParams, setSearchParams] = useSearchParams();


    // Get current filter values from URL or use defaults
    const currentMonth = searchParams.get('month') || new Date().getMonth() + 1;
    const currentYear = searchParams.get('year') || new Date().getFullYear();
    const currentApartmentIds = searchParams.get('apartment_ids') || '';

    // State for filters
    const [filters, setFilters] = useState({
        month: currentMonth,
        year: currentYear,
        apartment: currentApartmentIds
    });

    // Fetch data with current filters
    const { data,  error } = useGetUtilitiesSummaryDataQuery();



    // State for utility form data
    const [utilityData, setUtilityData] = useState({
        apartmentId: "",
        type: "",
        frequency: "",
        cost_per_unit: "",
        paymentType: "",
        title: ""
    });

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setUtilityData(prev => ({
            ...prev,
            [id]: value
        }));
    };

    useEffect(() => {
        if (onFiltersDashboardChange) {
            onFiltersDashboardChange(filters);
        }
    }, [filters]);


    // Available utility types
    const allUtilityTypes = ["Water", "Electricity", "Garbage", "Security", "Internet"];

    // Get existing utility types for selected apartment
    const getExistingUtilities = () => {
        if (!utilityData.apartmentId || !data?.landlord_expenses) return [];

        const apartment = data.landlord_expenses.find(
            apt => apt.apartment_id === parseInt(utilityData.apartmentId)
        );

        return apartment?.expenses?.map(exp => exp.expense_name) || [];
    };

    // Filter available utility types based on what's already added
    const availableUtilityTypes = allUtilityTypes.filter(
        type => !getExistingUtilities().includes(type)
    );


  const [exportUtilitiesReport, { isLoading: isExporting }] = useLazyGetUtilitiesReportExportsQuery ();



  const handleExport = async () => {
  try {
    const result = await exportUtilitiesReport({
      format: exportFormat,
      is_summary: exportOptions.is_summary,
      is_detailed: exportOptions.is_detailed,
      is_charts: exportOptions.is_charts,
    //   month: filters?.month,
    //   year: filters?.year,
    //   apartment_id: filters?.apartment,
    }).unwrap();

    // Handle the download
    const blobData = exportFormat === 'pdf'
      ? result // Already a Blob
      : new Blob([result], { type: 'text/csv' }); // Wrap string as Blob

    const url = window.URL.createObjectURL(blobData);
    const a = document.createElement('a');
    a.href = url;
    a.download = `utilities-report-${new Date().toISOString()}.${exportFormat}`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);

  } catch (error) {
    console.error("Export failed:", error);
    toast.error('Failed to export report');
  } finally {
    setShowExportModal(false);
  }
};


//   const handleExport = async () => {
//     try {
//       // Get current filters (make sure these are available in your component)
      
//       const result = await exportUtilitiesReport({
//         format: exportFormat,
//         is_summary: exportOptions.is_summary,
//         is_detailed: exportOptions.is_detailed,
//         is_charts: exportOptions.is_charts,
//         month: filters?.month,
//         year: filters?.year,
//         apartment_id: filters?.apartment
//       }).unwrap();

//       // Handle the download
//       const blob = new Blob([result], { 
//         type: exportFormat === 'pdf' ? 'application/pdf' : 'text/csv' 
//       });
//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement('a');
//       a.href = url;
//       a.download = `utilities-report-${new Date().toISOString()}.${exportFormat}`;
//       document.body.appendChild(a);
//       a.click();
//       window.URL.revokeObjectURL(url);
//       document.body.removeChild(a);
      
//     } catch (error) {
//       console.error("Export failed:", error);
//       // Show error toast
//       toast.error('Failed to export report');
//     } finally {
//       setShowExportModal(false);
//     }
//   };





    const accessToken = localStorage.getItem("authTokens");
    // get the access token
    const parsedTokens = JSON.parse(accessToken);
    const access = parsedTokens.access;


    // headers access token
    const config = {
        headers: { Authorization: `Bearer ${access}` }
    }

    useEffect(() => {
        if (utilityData.apartmentId) {
            setUtilityData(prev => ({
                ...prev,
                title: ""
            }));
        }
    }, [utilityData.apartmentId]);


    const handleAddUtility = () => {

        const utilityDataPost = {
            apartment: Number(utilityData.apartmentId),
            title: utilityData.title,
            frequency: utilityData.frequency,
            cost_per_unit: utilityData.cost_per_unit,
            expense_type: utilityData.paymentType,
        }

        try {
            serverUrl.post('/landlord/expense/', utilityDataPost, config)
                .then((res) => {
                    toast.success("Utility Succesffuly Added!")
                    // Here you would implement the actual add utility logic
                    setShowAddModal(false);
                    onUtilityChanged?.();
                    // Reset form data
                    setUtilityData({
                        apartmentId: "",
                        type: "",
                        title: "",
                        frequency: "",
                        cost_per_unit: "",
                        paymentType: ""
                    });
                })
                .catch((error) => {
                    toast.error(error)
                })
        }
        catch (error) {
            console.log(error);
        }
    };


    const handleFiltersChange = (newFilters) => {
        const updatedFilters = {
            ...filters,
            ...newFilters
        };
        setFilters(updatedFilters);

        // Update URL params
        const params = new URLSearchParams();
        params.set('month', updatedFilters.month);
        params.set('year', updatedFilters.year);

        if (updatedFilters.apartment && updatedFilters.apartment !== "all") {
            params.set('apartment_ids', updatedFilters.apartment);
        } else {
            params.delete('apartment_ids');
        }

        setSearchParams(params);
    };

    return (
        <div className="flex md:flex-row flex-col justify-between gap-4 mb-6">
            <div className="flex sm:flex-row flex-col flex-1 gap-4">
                {/* Property Select */}
                {/* <DateFilterRange propertyData={data?.landlord_expenses} onFiltersChange={handleFiltersChange} /> */}
                <DateFilterRange
                    propertyData={data?.landlord_expenses}
                    onFiltersChange={handleFiltersChange}
                    initialMonth={currentMonth}
                    initialYear={currentYear}
                    initialApartment={currentApartmentIds || "all"}
                />
            </div>

            <div className="flex sm:flex-row flex-col sm:items-end gap-3">
                <button
                    onClick={() => setShowExportModal(true)}
                    className="flex justify-center items-center bg-white hover:bg-gray-50 shadow-sm px-4 py-2 border border-gray-300 rounded-md text-gray-700 transition-colors"
                >
                    <Download className="mr-2 w-4 h-4" />
                    Export Report
                </button>
                <button
                    onClick={() => setShowAddModal(true)}
                    className="flex justify-center items-center bg-blue-600 hover:bg-blue-700 shadow-sm px-4 py-2 rounded-md text-white transition-colors"
                >
                    <Plus className="mr-2 w-4 h-4" />
                    Add Utility
                </button>
            </div>

            {/* Add Utility Modal */}
            {showAddModal && (
                <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 p-4">
                    <div className="bg-white shadow-xl rounded-lg w-full max-w-md">
                        <div className="flex justify-between items-center px-6 py-4 border-b">
                            <h3 className="font-semibold text-gray-900 text-lg">Add New Utility</h3>
                            <button
                                onClick={() => setShowAddModal(false)}
                                className="text-gray-400 hover:text-gray-500"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>
                        <div className="space-y-4 p-6">
                            <div>
                                <p htmlFor="apartmentId" className="block mb-1 font-extrabold text-gray-700 text-lg">
                                    Apartment
                                </p>
                                <select
                                    id="apartmentId"
                                    className="block shadow-sm px-4 py-2 border border-gray-300 focus:border-blue-500 rounded-md focus:ring-blue-500 w-full"
                                    value={utilityData.apartmentId}
                                    onChange={handleInputChange}
                                >
                                    <option disabled value="">Select apartment</option>
                                    {data?.landlord_expenses?.map((apartment) => (
                                        <option key={apartment.apartment_id} value={apartment.apartment_id}>
                                            {apartment.apartment_name}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div>
                                <p htmlFor="title" className="block mb-1 font-extrabold text-gray-700 text-lg">
                                    Utility Type
                                </p>
                                <select
                                    id="title"
                                    className="block shadow-sm px-4 py-2 border border-gray-300 focus:border-blue-500 rounded-md focus:ring-blue-500 w-full"
                                    value={utilityData.title}
                                    onChange={handleInputChange}
                                    disabled={!utilityData.apartmentId}
                                >
                                    <option disabled value="">Select utility type</option>
                                    {availableUtilityTypes.length > 0 ? (
                                        availableUtilityTypes.map(type => (
                                            <option key={type} value={type}>
                                                {type}
                                            </option>
                                        ))
                                    ) : (
                                        <option disabled value="">
                                            {utilityData.apartmentId ?
                                                "All utility types already added for this apartment" :
                                                "Please select an apartment first"}
                                        </option>
                                    )}
                                </select>
                            </div>


                            <div>
                                <p htmlFor="frequency" className="block mb-1 font-extrabold text-gray-700 text-lg">
                                    Payment Frequency
                                </p>
                                <select
                                    id="frequency"
                                    className="block shadow-sm px-4 py-2 border border-gray-300 focus:border-blue-500 rounded-md focus:ring-blue-500 w-full"
                                    value={utilityData.frequency}
                                    onChange={handleInputChange}
                                >
                                    <option disabled value="">Select payment frequency</option>
                                    <option value="monthly">Monthly</option>
                                    <option value="daily">Daily</option>
                                    <option value="annually">Annually</option>
                                    <option value="weekly">Weekly</option>
                                </select>
                            </div>

                            <div>
                                <p htmlFor="cost_per_unit" className="block mb-1 font-extrabold text-gray-700 text-lg">
                                    Cost Per Unit (in KES)
                                </p>
                                <input
                                    type="number"
                                    id="cost_per_unit"
                                    className="block shadow-sm px-4 py-2 border border-gray-300 focus:border-blue-500 rounded-md focus:ring-blue-500 w-full"
                                    placeholder="0.00"
                                    value={utilityData.cost_per_unit}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div>
                                <p htmlFor="paymentType" className="block mb-1 font-extrabold text-gray-700 text-lg">
                                    Payment Structure
                                </p>
                                <select
                                    id="paymentType"
                                    className="block shadow-sm px-4 py-2 border border-gray-300 focus:border-blue-500 rounded-md focus:ring-blue-500 w-full"
                                    value={utilityData.paymentType}
                                    onChange={handleInputChange}
                                >
                                    <option disabled value="">Select payment structure</option>
                                    <option value="fixed">Fixed Amount</option>
                                    <option value="varying">Variable (Based on Usage)</option>
                                </select>
                            </div>
                        </div>
                        <div className="flex justify-end gap-3 px-6 py-4 border-t">
                            <button
                                onClick={() => setShowAddModal(false)}
                                className="hover:bg-gray-50 px-4 py-2 border border-gray-300 rounded-md text-gray-700 transition-colors"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleAddUtility}
                                className="bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded-md text-white transition-colors"
                            >
                                Save Utility
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Export Report Modal */}
            {showExportModal && (
                <div className="z-50 fixed inset-0 flex justify-center items-center bg-black bg-opacity-50 p-4">
                    <div className="bg-white shadow-xl rounded-lg w-full max-w-md">
                        <div className="flex justify-between items-center px-6 py-4 border-b">
                            <p className="font-semibold text-gray-900 text-lg">Export Report</p>
                            <button
                                onClick={() => setShowExportModal(false)}
                                className="text-gray-400 hover:text-gray-500"
                            >
                                <X className="w-5 h-5" />
                            </button>
                        </div>
                        <div className="space-y-6 p-6">
                            <div>
                                <p className="mb-3 font-medium text-gray-700 text-sm">Export Format</p>
                                <div className="gap-3 grid grid-cols-2">
                                    {["pdf", "csv"].map((format) => (
                                        <button
                                            key={format}
                                            onClick={() => setExportFormat(format)}
                                            className={`px-4 py-2 border rounded-md flex items-center justify-center transition-colors ${exportFormat === format
                                                ? 'border-blue-500 bg-blue-50 text-blue-600'
                                                : 'border-gray-300 hover:bg-gray-50'
                                                }`}
                                        >
                                            {format.toUpperCase()}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <p className="mb-3 font-medium text-gray-700 text-sm">Include</p>
                                <div className="space-y-2">
                                    {[
                                        { id: 'is_summary', text: 'Summary' },
                                        { id: 'is_detailed', text: 'Detailed Data' },
                                        // { id: 'is_charts', text: 'Charts' }
                                    ].map((option) => (
                                        <div key={option.id} className="flex items-center">
                                            <input
                                                id={option.id}
                                                type="checkbox"
                                                checked={exportOptions[option.id]}
                                                onChange={() => setExportOptions(prev => ({
                                                    ...prev,
                                                    [option.id]: !prev[option.id]
                                                }))}
                                                className="border-gray-300 rounded focus:ring-blue-500 w-4 h-4 text-blue-600"
                                            />
                                            <p className="mt-3 ml-2 text-gray-700 text-sm">
                                                {option.text}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="flex justify-end gap-3 px-6 py-4 border-t">
                            <button
                                onClick={() => setShowExportModal(false)}
                                className="hover:bg-gray-50 px-4 py-2 border border-gray-300 rounded-md text-gray-700 transition-colors"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleExport}
                                disabled={isExporting}
                                className="flex items-center bg-blue-600 hover:bg-blue-700 disabled:opacity-50 px-4 py-2 rounded-md text-white transition-colors"
                            >
                                {isExporting ? 'Exporting...' : (
                                    <>
                                        <Download className="mr-2 w-4 h-4" />
                                        Export Report
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
